const $ = require('jquery');
import run from '../../utilities/run';
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run(".retailer-detail-outer-section", ()=>{
	const el = $(".retailer-detail-outer-section");
	const changeStatusUrl = el.data("change-status-url");
	const changeSubMerchantStatusUrl = el.data("change-child-status-url");
	const pageReloadUrl = el.data("retailer-detail-page-reload-url");
	const resubmitMerchantUrl = el.data("generate-retailer-ean-number-url");

	const els = {};
	const elementsMap = {
		activateBtn : ".retailer-activate-btn",
		editBtn : ".retailer-edit-btn",
		deactivateBtn : ".retailer-deactivate-btn",
		generateEanNumberDiv : ".generate-ean-number",
		generateEanBtn : ".generate-ean-btn",
		rtlEanNumber : ".rtl-ean-number",
		activateChildBtn: ".activate-merchant-btn",
		deactivateChildBtn: ".deactivate-merchant-btn"
	};

	setElements();
	onLoad();

  function setElements() {
    setElementsFromScope(els, elementsMap, el);
  }

	function onLoad(){
		checkEanNumber();
	}

	function checkEanNumber(){
		if(els.rtlEanNumber.text().length > 1){
			els.generateEanNumberDiv.hide();
		}else{
			els.generateEanNumberDiv.show();
		}
	}
	const activateRetailerModal = new SubmitModalFlow({
    confirmModalTitle: 'Activate Retailer',
		confirmModalBody: `<div class="q-pad-all-xl">
				              <p>By reactivating this retailer, they will resume their previous privileges with the service.</p>
                      <p>Do you wish to continue?</p>
						  </div>`,
		confirmModalBtnText: 'Activate Rule',
		onConfirmClick: function(){
			activateRetailerModal.showLoadingModal();
			handleActivateDeactivate({url: changeStatusUrl, input: "A", success:activeSuccess, error: activeError});
		}
	});

	activateRetailerModal.init();

	const deactiveRetailerModal = new SubmitModalFlow({
		confirmModalTitle: 'Deactive Retailer',
		confirmModalBody: `<div class="q-pad-all-xl">
							<p>By deactivating this retailer, they will no longer have privileges to use this service.</p>
              <p>Do you wish to continue?</p>
						  </div>`,
		confirmModalBtnText: 'Deactive Retailer',
		onConfirmClick: function(){
			deactiveRetailerModal.showLoadingModal();
			handleActivateDeactivate({url: changeStatusUrl, input: "I", success:deactiveSuccess, error: deactiveError});
		}
	});

	deactiveRetailerModal.init();

	els.activateBtn.on("click", function(e){
		e.preventDefault();
		activateRetailerModal.showConfirmModal();
	});

	els.deactivateBtn.on("click", function(e){
		e.preventDefault();
		deactiveRetailerModal.showConfirmModal();
	});

	function handleActivateDeactivate({url, input, success, error}){
		$.ajax({
			url: url,
			data:{"status" : input},
			dataType:"JSON",
			type: 'POST',
			success: success,
			error: error
		});
	}

	function activeSuccess(data){
		if(data.response === "success"){
			EditChecker.setPageClean();
			const detailUrlFullURL = pageReloadUrl;
			activateRetailerModal.showSuccessModal();
			setTimeout(function() {
				location.href = detailUrlFullURL;
			}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			activateRetailerModal.showFailureModal();
		}
	}

	function activeError(){
	  activateRetailerModal.hideAllModals();
	}

	function deactiveSuccess(data){
		if(data.response === "success"){
			EditChecker.setPageClean();
			const detailUrlFullURL = pageReloadUrl;
			deactiveRetailerModal.showSuccessModal();
			setTimeout(function() {
			 location.href = detailUrlFullURL;
			},SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			deactiveRetailerModal.showFailureModal();
		}
	}

	function deactiveError(){
		deactiveRetailerModal.hideAllModals();
	}

    let deActivateSubRetailerModal = null;
	els.deactivateChildBtn.on("click", function(e){

		e.preventDefault();
		let chrId = $(e.target).attr('data-chrId');	
		deActivateSubRetailerModal = new SubmitModalFlow({
		confirmModalTitle: 'Deactivate Merchant',
		confirmModalBody: `<div class="q-pad-all-xl">
							<p>This will remove the affiliated merchant. The merchant will no longer able to select this affiliated merchant for returns. Please confirm you wish to do this.</p>
						  </div>`,
		confirmModalBtnText: 'Confirm',
		onConfirmClick: function(){
			deActivateSubRetailerModal.showLoadingModal();
			handleChildActivateDeactivate({url: changeSubMerchantStatusUrl, input: chrId , success:deactiveChildSuccess, error: deactiveChildError});
		}
	});
		deActivateSubRetailerModal.init();

		deActivateSubRetailerModal.showConfirmModal();
	});
	let activateSubRetailerModal = null;
	els.activateChildBtn.on("click", function(e){

		e.preventDefault();
		let chrId = $(e.target).attr('data-chrId');	
		activateSubRetailerModal = new SubmitModalFlow({
	    	confirmModalTitle: 'Activate Merchant',
			confirmModalBody: `<div class="q-pad-all-xl">
					              <p>This will show this affiliated merchant for this merchant to select for returns.Please confirm you wish to do this.</p>
							  </div>`,
			confirmModalBtnText: 'Confirm',
			onConfirmClick: function(){
				activateSubRetailerModal.showLoadingModal();
				handleChildActivateDeactivate({url: changeSubMerchantStatusUrl, input: chrId, success:activeChildSuccess, error: activeChildError});
			}
		});
		activateSubRetailerModal.init();

		activateSubRetailerModal.showConfirmModal();
	});

	function handleChildActivateDeactivate({url, input, success, error}){
		$.ajax({
			url: url,
			data:{"chrId" : input},
			dataType:"JSON",
			type: 'POST',
			success: success,
			error: error
		});
	}

	function activeChildSuccess(data){
		if(data.response === "success"){
			EditChecker.setPageClean();
			const detailUrlFullURL = pageReloadUrl;
			activateSubRetailerModal.showSuccessModal();
			setTimeout(function() {
				location.href = detailUrlFullURL;
			}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			activateSubRetailerModal.showFailureModal();
		}
	}

	function activeChildError(){
	  activateSubRetailerModal.hideAllModals();
	}

	function deactiveChildSuccess(data){
		if(data.response === "success"){
			EditChecker.setPageClean();
			const detailUrlFullURL = pageReloadUrl;
			deActivateSubRetailerModal.showSuccessModal();
			setTimeout(function() {
			 location.href = detailUrlFullURL;
			},SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			deActivateSubRetailerModal.showFailureModal();
		}
	}

	function deactiveChildError(){
		deActivateSubRetailerModal.hideAllModals();
	}


	els.generateEanBtn.on('click', function(){
    $.ajax({
        url: resubmitMerchantUrl,
        type: 'POST',
        dataType: 'json',
        data:[],
        success: function (resp) {
            if (resp.data && resp.data != null && resp.data != 'null') {
              els.rtlEanNumber.text(resp.data);
							els.generateEanNumberDiv.hide();
            } else{
							els.generateEanNumberDiv.show();
            }
        },
        error: function (xhr, status, error) {
					els.generateEanNumberDiv.show();
        }
    });
    
	});

});



// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/details.js